import { Router, activationStrategy } from 'aurelia-router';
import { autoinject, bindable, bindingMode } from 'aurelia-framework';

import { BaseView } from 'Common/BaseView';
import { DataService } from 'DataAccessLayer/Services/DataService';
import { StringHelper } from 'Code/Helpers/StringHelper';
import { SystemService } from 'DataAccessLayer/Services/SystemService';

@autoinject
export class DashboardBaseView extends BaseView {

    @bindable({ defaultBindingMode: bindingMode.toView }) entityName: string = null;
    @bindable({ defaultBindingMode: bindingMode.twoWay }) mode: string = 'dashboard';
    @bindable({ defaultBindingMode: bindingMode.twoWay }) selectedTab: string = null;

    protected schema: Object = null;
    protected router: Router = null;
    protected routeConfig: any = null;

    constructor(router: Router) {
        super();

        this.router = router;
    }

    activate(params, routeConfig, $navigationInstruction) {
        this.entityName = 'Dashboard';
        this.routeConfig = routeConfig;
    }

    async bind() {
        //
        //this.schema = await SystemService.Instance.GetEntityEnumeration(this.entityName);
        this.schema = await this.fake_data();
    }

    private async fake_data() {
        return {
            "Title": "Home",
            "Rows": [
                {
                    "Id": "1",
                    "Blocks": [
                        {
                            "BlockSize": "1",
                            "Widgets": [
                                {
                                    "Name": "HomeContent",
                                    "Title": "SHARP",
                                    "Description": "SHARP",
                                    "Type": "html",
                                    "Settings": {
                                        "Content": "<div class='row'> <div class='col-lg-6 col-md-6 col-sm-12 col-xs-12 text-center' style='padding: 50px;'> <div class='logo'><img src='public/images/SHARP_logo.png' style='width: 100%;max-width: 360px;'/></div></div><div class='col-lg-6 col-md-6 col-sm-12 col-xs-12 text-center'> <ul style='list-style:none;font-size: 20px;padding: 10px;line-height: 35px;'> <li><a href='#/ConfirmAssignment' class='btn btn-default' style='width:100%; max-width: 450px;height: 50px;font-size: 16px;line-height: 35px;margin: 5px;'>Confirm Assignment</a></li><li><a href='#/WorkOrderQuickCreate/quick' class='btn btn-default' style='width:100%; max-width: 450px;height: 50px;font-size: 16px;line-height: 35px;margin: 5px;'>Service a Unit</a></li><li><a href='#/TimeCard/create' class='btn btn-default' style='width:100%; max-width: 450px;height: 50px;font-size: 16px;line-height: 35px;margin: 5px;'>Log Your Timesheet</a></li></ul> </div></div>"
                                    }
                                }
                            ]
                        }
                    ]
                },
                {
                    "Id": "2",
                    "Blocks": [
                        {
                            "BlockSize": "2",
                            "Widgets": [
                                {
                                    "Name": "Chart01",
                                    "Title": "Chart 01",
                                    "Description": "Chart 01",
                                    "Type": "system_chart",
                                    "Settings": {
                                        "ChartType": "line",
                                        "ChartLabel": "Any text here",
                                        "RotatedAxis": false,
                                        "GroupValues": false,
                                        "EnableZoom": false,
                                        "ShowSubchart": false,
                                        "ShowLegend": true,
                                        "ShowGridX": true,
                                        "ShowGridY": true,
                                        "DataLabel": "Count of units per months",
                                        "SpName": "sp_api_SHARP_Dashboard_Unit",
                                        "SpParameters": {}
                                    }
                                }
                            ]
                        },
                        {
                            "BlockSize": "2",
                            "Widgets": [
                                {
                                    "Name": "Chart02",
                                    "Title": "Chart 02",
                                    "Description": "Chart 02",
                                    "Type": "system_chart",
                                    "Settings": {
                                        "ChartType": "bar",
                                        "ChartLabel": "Any text here",
                                        "RotatedAxis": false,
                                        "GroupValues": false,
                                        "EnableZoom": false,
                                        "ShowSubchart": false,
                                        "ShowLegend": true,
                                        "ShowGridX": true,
                                        "ShowGridY": true,
                                        "DataLabel": "Sum price with tax",
                                        "SpName": "sp_api_SHARP_Dashboard_Unit_Ex",
                                        "SpParameters": {
                                            "DateFrom": "2016-03-01",
                                            "DateTo": "2017-03-31"
                                        }
                                    }
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    }
}